import { createSvgIcon } from 'shared/icons/IconUtils';
import { ColorDynamic } from '@superdispatch/ui';

export const CircleAlertIcon = createSvgIcon(
  'CircleAlertIcon',
  <path
    d="M34.6667 34.6663H29.3333V18.6663H34.6667V34.6663ZM34.6667 45.333H29.3333V39.9997H34.6667V45.333ZM32 5.33301C28.4981 5.33301 25.0305 6.02276 21.7951 7.36289C18.5598 8.70301 15.6201 10.6673 13.1438 13.1435C8.14286 18.1445 5.33334 24.9272 5.33334 31.9997C5.33334 39.0721 8.14286 45.8549 13.1438 50.8559C15.6201 53.3321 18.5598 55.2963 21.7951 56.6365C25.0305 57.9766 28.4981 58.6663 32 58.6663C39.0724 58.6663 45.8552 55.8568 50.8562 50.8559C55.8572 45.8549 58.6667 39.0721 58.6667 31.9997C58.6667 28.4978 57.9769 25.0301 56.6368 21.7948C55.2967 18.5594 53.3324 15.6197 50.8562 13.1435C48.38 10.6673 45.4403 8.70301 42.2049 7.36289C38.9696 6.02276 35.5019 5.33301 32 5.33301Z"
    fill={ColorDynamic.Silver500}
  />,
  { viewBox: '0 0 64 64', style: { height: '64px', width: '64px' } },
);
